// removed by extract-text-webpack-plugin
module.exports = {"iconText":"PlayerStatus__iconText--18d9K","printableIconText":"PlayerStatus__printableIconText--33HO9","iconsFirstLine":"PlayerStatus__iconsFirstLine--1z0Pr","iconsSecondLine":"PlayerStatus__iconsSecondLine--2u8ji","printableIconsSecondLine":"PlayerStatus__printableIconsSecondLine--22MLA"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/TableControls/PlayerStatus/PlayerStatus.css
// module id = MKAW
// module chunks = 47